import Resource from '@/api/resources/Resource'
import { PAGINATOR_BIG_PAGE_SIZE } from '@/shared/services/services-constants'
import { orderBy } from 'lodash'
import { TextNormalization } from '@/shared/util/text-normalization'

class ArchiveFilterService extends Resource {
    constructor() {
        super()
        this.samplePendingUnarchivingReasons = []
        this.portionPendingUnarchivingReasons = []
        this.subportionPendingUnarchivingReasons = []
    }

    async getSummary(laboratoryId) {
        return this.axios.get(`/archive/laboratories/${laboratoryId}/cases/samples/summary`).then(response => response.data)
    }
    async paginator(filterModel, params, laboratoryId, url) {
        const response = await this.axios.put(`/archive/laboratories/${laboratoryId}/${url}`, filterModel, { params })
        return response.data
    }
    async exportTo(laboratoryId, sectionLabel, filterModel, sortModel, columns, selectedIds, url, entitySubtype, exportType) {
        const params = {
            page: 0,
            size: PAGINATOR_BIG_PAGE_SIZE,
            sort: sortModel,
            entitySubtype,
            exportType
        }
        return this.axios.put(
            `/archive/laboratories/${laboratoryId}/${url}/exportToPdf`,
            { sectionLabel, filterModel, columns, entityIdentifiersRequest: selectedIds },
            { params, responseType: 'arraybuffer' })
    }
    async loadSamplePendingUnarchivingReasons() {
        const response = await this.axios.get(`/archive/laboratories/samplePendingUnarchivingReasons`)
        const pendingUnarchivingReasons = orderBy(response.data, element => TextNormalization.removeDiacritics(element.name), ['asc'])
        this.samplePendingUnarchivingReasons = pendingUnarchivingReasons
    }
    getSamplePendingUnarchivingReasons() {
        return this.samplePendingUnarchivingReasons
    }
    async loadPortionPendingUnarchivingReasons() {
        const response = await this.axios.get(`/archive/laboratories/portionPendingUnarchivingReasons`)
        const pendingUnarchivingReasons = orderBy(response.data, element => TextNormalization.removeDiacritics(element.name), ['asc'])
        this.portionPendingUnarchivingReasons = pendingUnarchivingReasons
    }
    getPortionPendingUnarchivingReasons() {
        return this.portionPendingUnarchivingReasons
    }
    async loadSubportionPendingUnarchivingReasons() {
        const response = await this.axios.get(`/archive/laboratories/subportionPendingUnarchivingReasons`)
        const pendingUnarchivingReasons = orderBy(response.data, element => TextNormalization.removeDiacritics(element.name), ['asc'])
        this.subportionPendingUnarchivingReasons = pendingUnarchivingReasons
    }
    getSubportionPendingUnarchivingReasons() {
        return this.subportionPendingUnarchivingReasons
    }
}
export default new ArchiveFilterService()
